var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-339b5517-4b70-4fb6-bcfe-9f463f095be0",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.13,81.41c-2.83-1.66-5.24-2.78-6.9-3.49-4.09-1.76-6.14-2.1-9.22-3.99-2.22-1.36-3.81-2.8-4.79-3.78v-8.62c1.9-2.21,3.33-4.22,4.36-5.81,2.31-3.57,1.3-2.96,3.39-6.39,.23-.38,.61-1.02,.65-1.9,.08-1.94-1.53-3.17-1.7-3.29,.44-1.58,.97-3.82,1.28-6.56,.37-3.28,.61-5.22,.04-7.77-.65-2.92-1.92-4.76-2.22-5.19-.23-.33-1.05-1.46-2.45-2.63-2.08-1.74-4.1-2.45-5.31-2.87-2.68-.91-5.12-1.08-6.93-1.01",
    style: {
      fill: "none",
      stroke: "#283a50",
      strokeMiterlimit: 10,
      strokeWidth: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.95,81.42c2.83-1.66,5.24-2.78,6.9-3.49,4.09-1.76,6.14-2.1,9.22-3.99,2.22-1.36,3.81-2.8,4.79-3.78v-8.62c-1.9-2.21-3.33-4.22-4.36-5.81-2.31-3.57-1.3-2.96-3.39-6.39-.23-.38-.61-1.02-.65-1.9-.08-1.94,1.53-3.17,1.7-3.29-.44-1.58-.97-3.82-1.28-6.56-.37-3.28-.61-5.22-.04-7.77,.65-2.92,1.92-4.76,2.22-5.19,.23-.32,1.05-1.46,2.45-2.63,2.07-1.73,4.08-2.44,5.31-2.87,1.28-.44,3.22-.95,5.66-1.02",
    style: {
      fill: "none",
      stroke: "#283a50",
      strokeMiterlimit: 10,
      strokeWidth: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.46,83.55c-.06-.29-.17-.61-.35-.95-.66-1.25-1.84-1.77-2.31-1.95",
    style: {
      fill: "none",
      stroke: "#283a50",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.63,83.55c.06-.29,.17-.61,.35-.95,.66-1.25,1.84-1.77,2.31-1.95",
    style: {
      fill: "none",
      stroke: "#283a50",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 10
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgProfile);
export default __webpack_public_path__ + "static/media/SvgProfile.ad7147127887d47c6573926ab512e177.svg";
export { ForwardRef as ReactComponent };